export const sliderValueToInchesMapping = [
  { sliderValue: 0, inches: 24 },
  { sliderValue: 1, inches: 32 },
  { sliderValue: 2, inches: 40 },
  { sliderValue: 3, inches: 43 },
  { sliderValue: 4, inches: 50 },
  { sliderValue: 5, inches: 55 },
  { sliderValue: 6, inches: 60 },
  { sliderValue: 7, inches: 65 },
  { sliderValue: 8, inches: 70 },
  { sliderValue: 9, inches: 75 },
  { sliderValue: 10, inches: null },
]

export function trimQuotes(str: string): string {
  return str.replace(/^["']|["']$/g, '')
}
export function convertTvSizeValueToInches(value: number): number | null {
  const sizeOption = sliderValueToInchesMapping.find(
    (option) => option.sliderValue === value,
  )
  return sizeOption?.inches ?? null
}

export function convertIncheseToSelectedSliderValue(
  inches: number,
): number | null {
  const sizeOption = sliderValueToInchesMapping.find(
    (option) => option.inches === inches,
  )
  return sizeOption ? sizeOption.sliderValue : null // Return 10 for 'Custom' if no match is found
}

export function validateInchesFormat(input: string): boolean {
  const regex = /^\d+"?$/
  return regex.test(input)
}
